import { ApiVersion } from '@/config';
import { IIncidentCode, IIncidentCodePayload } from '@/models/incident.code';

import { http } from './http';

const BASE_PATH = '/incident-codes';

interface IListParams {
  page?: number;
  limit?: number;
  search?: string;
  sort?: string;
}

export const IncidentCodeApi = {
  list: async (params: IListParams = {}): Promise<IIncidentCode[]> => {
    const response = await http.get(`api/${ApiVersion.V1}${BASE_PATH}`, {
      params,
    });
    return Array.isArray(response.data) ? response.data : [];
  },

  getById: async (id: string): Promise<IIncidentCode> => {
    const response = await http.get(`api/${ApiVersion.V1}${BASE_PATH}/${id}`);
    return response.data;
  },

  create: async (payload: IIncidentCodePayload): Promise<IIncidentCode> => {
    const response = await http.post(
      `api/${ApiVersion.V1}${BASE_PATH}`,
      payload as unknown as IIncidentCode,
    );
    return response.data;
  },

  update: async (
    id: string,
    payload: Partial<IIncidentCodePayload>,
  ): Promise<IIncidentCode> => {
    const response = await http.put(
      `api/${ApiVersion.V1}${BASE_PATH}/${id}`,
      payload as unknown as IIncidentCode,
    );
    return response.data;
  },

  remove: async (id: string): Promise<{ message: string }> => {
    const response = await http.delete(
      `api/${ApiVersion.V1}${BASE_PATH}/${id}`,
    );
    return response.data;
  },
};
